import styled from 'styled-components';

export const Form = styled.form`

`;

export const Container = styled.div`

  &:not(&:last-child) {
    margin-bottom: 32px;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 10px;
`;

export const Error = styled.div`
  margin-top: 10px;
  color: #f57361;
`;
